<div class="modal-header">
    <h4>Support</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <p>To get technical support please reach out to DK AU2MATION.</p>

                <p>We suggest trying to reach out by mail to DK AU2MATION <a href="mailto:jutlandia@dkau2mation.nu">jutlandia&#64;dkau2mation.nu</a></p>

                <p>If urgent you can try reach out on the main line at: <a href="tel:+4561880088">+45 61 88 00 88</a></p>


            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <div class="btn-group">
        <button class="btn btn-primary" (click)="cancel()">Close</button>
    </div>
</div>
